module.exports = __webpack_public_path__ + "img/laptop-ow-vision.ecd97e02.png";